<app-flex-container [isVertical]="true" class="page-background">
  <app-header-maxi *ngIf="showMaxiHeader"></app-header-maxi>
  <app-header-mini *ngIf="!showMaxiHeader"></app-header-mini>
  <app-flex-item class="zit-scrollbar-light" [height]="showMaxiHeader ? 'calc(100vh - 360px)' : '100%'">
    <ng-content select="[router-outlet]"></ng-content>
  </app-flex-item>
  <app-footer></app-footer>
</app-flex-container>
